import { isEmpty } from 'lodash';
import { useContext } from 'react';
import { GCFProductsContext } from 'src/components/context';
import { useGetProducts } from 'src/hooks';
import { mapProductToGCFGroupProduct } from 'src/utils/product';

import { formatProduct } from './EditProductPanel.helper';
import { EditProductPanelProps } from './EditProductPanel.interface';

export const useEditProductPanel = ({
  editProduct,
  onChange,
  productCategoryIDs,
}: EditProductPanelProps) => {
  const { value: gcfProducts, onChangeGCFProductStatus } =
    useContext(GCFProductsContext);

  const { data: products = [] } = useGetProducts(
    !isEmpty(productCategoryIDs)
      ? [`product_category_id=${productCategoryIDs?.join('|')}`]
      : [],
  );

  const onSelectedProductCode = (value: unknown) => {
    const product = products.find((item) => item.product_code === value);

    if (product) {
      const gcfGroupProduct = mapProductToGCFGroupProduct(
        product,
        editProduct.order,
      );

      onChange(gcfGroupProduct);
    }
  };

  return {
    products,
    currentProduct: formatProduct(
      products.find((item) => item.product_code === editProduct.productCode),
      gcfProducts[editProduct.productCode],
    ),
    onSelectedProductCode,
    onChangeGCFProductStatus,
  };
};
